import {useParams} from "react-router-dom";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentDetailUrlClickValueObject} from "../../../../data/value-object/content/ContentDetailUrlClickValueObject";
import {useEffect} from "react";
import {Body1, Spinner} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailDefaultTab} from "../../../DetailViews";
import {ContentDetailUrlClickDescription} from "../../../../data/description/content/ContentDetailUrlClickDescription";
import {ContentDetailUrlClickIO} from "../../../../io/ContentIO";
import {ContentDetailUrlClickDomain} from "../../../../data/domain/content/ContentDetailUrlClickDomain";
import {ContentDetailUrlClickDescriptor} from "../../../../data/descriptor/content/ContentDetailUrlClickDescriptor";

export default function Detail(props: RouterProps) {
    const params = useParams<{ contentDetailUrlClickId: string }>()
    const item = useStatePair<ContentDetailUrlClickValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.contentDetailUrlClickId !== undefined) {
            ContentDetailUrlClickIO
                .getById(BigInt(params.contentDetailUrlClickId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: ContentDetailUrlClickValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={ContentDetailUrlClickIO}
                description={ContentDetailUrlClickDescription}
                properties={props => <PropertyBody {...props} />}
                hideEdit
                hideDelete/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof ContentDetailUrlClickDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "createdAt":
            return <Body1>{ContentDetailUrlClickDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{ContentDetailUrlClickDescriptor[props.itemKey](props.item)}</Body1></a>
        case "contentDetailUrlId":
            return <a href={`/contents/detailUrls/${props.item.contentDetailUrlId}`}><Body1>{ContentDetailUrlClickDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}